

















































import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";
import moment from "moment";
import util from "@/lib/util";

@Component
export default class ProductHistory extends AbpBase {
  created() {}

  formatDate(date) {
    return moment(date).format("DD/MM/YYYY HH:mm:ss");
  }

  get productHistorys() {
    console.log(this.$store.state.product.productHistory);
    return this.$store.state.product.productHistory;
  }

  getImageUrl(relativePath) {
    relativePath = relativePath.replaceAll('"', "");
    return util.getAppUrlImage(relativePath);
  }

  column = [
    {
      title: "Thông tin",
      key: "infoName",
      align: "center",
    },
    {
      title: "Giá trị cũ",
      align: "center",
      slot: "oldValue",
    },
    {
      title: "Giá trị mới",
      align: "center",
      slot: "newValue",
    },
  ];
}
